import { createActions, createReducer } from 'reduxsauce'

import TipoObraService from '../servicos/TipoObraService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTipoInicio: [],
    buscaTipoSucesso: ['tipo'],
    buscaTipoErro: ['erro'],
    limpar: [],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTipo = filtro => {
    return dispatch => {
        dispatch(Creators.buscaTipoInicio())
        let serv = new TipoObraService()
        return serv
            .getTipoObra()
            .then(response => dispatch(Creators.buscaTipoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTipoErro(error)))
    }
}

const buscaTipoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTipoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTipoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipo, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TIPO_INICIO]: buscaTipoInicio,
    [Types.BUSCA_TIPO_ERRO]: buscaTipoErro,
    [Types.BUSCA_TIPO_SUCESSO]: buscaTipoSucesso,
    [Types.LIMPAR]: limpar,
})
